import { __awaiter } from 'tslib';
import { getInitializedProvider } from './walletConnect/walletConnectV2.js';

const initializeWalletProviders = ({ evmNetworks, isWalletConnectV2Enabled, walletConnectProjectId, }) => __awaiter(void 0, void 0, void 0, function* () {
    if (isWalletConnectV2Enabled) {
        yield getInitializedProvider({ projectId: walletConnectProjectId }, evmNetworks);
    }
});

export { initializeWalletProviders };
